import React, { createContext, useContext } from 'react'

const JobContext = createContext()
export const useJobConfig = () => useContext(JobContext)

export default JobContext.Provider
